/* tslint:disable */
/* eslint-disable */
export enum ProjectType {
  None = 'None',
  Construction = 'Construction',
  Consulting = 'Consulting',
  Supply = 'Supply',
  Maintenance = 'Maintenance'
}
